import { render, staticRenderFns } from "./RatingCard.vue?vue&type=template&id=aba6826c&"
import script from "./RatingCard.vue?vue&type=script&lang=ts&setup=true&"
export * from "./RatingCard.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('aba6826c')) {
      api.createRecord('aba6826c', component.options)
    } else {
      api.reload('aba6826c', component.options)
    }
    module.hot.accept("./RatingCard.vue?vue&type=template&id=aba6826c&", function () {
      api.rerender('aba6826c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/HeroSection/components/RatingCard.vue"
export default component.exports